module.exports = __webpack_public_path__ + "static/img/support.1750914931681.png";